import { useFeatureFlags } from 'utils/features';

export default function useProjectPlanningIsEnabled(): boolean {
  return useFeatureFlags('RESOURCE_PLANNING');
}
